<div class="modal-header">
  <h2 class="modal-title" id="modal-edit-custom-field-title">
  {{ (customField?.fieldType !== customFieldTypeEnum.CheckboxField 
      ? 'signatureSideSelli.edit.textHeader' 
      : 'signatureSideSelli.edit.selectionHeader') | translate }}
  </h2>
  <button class="cdx-button cdx-button--icon" aria-describedby="modal-edit-custom-field-title" (click)="onClose()">
    <fa-icon class="fa-fw cdx-button__icon" [icon]="['fas', 'times']"></fa-icon>
  </button>
</div>

<div class="modal-body">
  <form [formGroup]="componentForm">
    <div class="form-row">
      <div *ngIf="customField?.fieldType !== customFieldTypeEnum.CheckboxField" class="form-group col-12">
        <div class="d-flex align-items-center justify-content-between">
          <cdx-label style="line-height: 18px !important;" [options]="{ label: 'signatureSideSelli.edit.displayName', labelFor: 'displayName' }"></cdx-label>
          <fa-icon ngbTooltip="{{'signatureSideSelli.edit.textTooltip' | translate}}" placement="left"
                class="ml-1 mr-1" size="sm" [icon]="['fas','question-circle']">
          </fa-icon>
        </div>
        <input
          id="displayName"
          type="text"
          class="form-control"
          maxlength="120"
          formControlName="displayName" />
      </div>
    
      <div class="form-group col-12">
        <cdx-label
          style="line-height: 18px !important;" 
          [options]="{
            label: customField?.fieldType !== customFieldTypeEnum.CheckboxField
              ? 'signatureSideSelli.edit.textFontSize'
              : 'signatureSideSelli.edit.selectionFontSize',
            labelFor: 'fontSize'
          }">
        </cdx-label>
        <cdx-dropdown
          [options]="fontSizedropdown"
          [selectedItem]="fontSizeSelected"
          (onSelectItem)="onFontSizeSelectItem($event)">
        </cdx-dropdown>
        <div class="text-helper" *ngIf="customField?.fieldType === customFieldTypeEnum.CheckboxField" >{{ 'signatureSideSelli.edit.selectionFontSizeDescription' | translate}}</div>
      </div>

      <div *ngIf="customField?.fieldType !== customFieldTypeEnum.CheckboxField" class="form-group col-12">
        <div class="d-flex align-items-center justify-content-between">
          <cdx-label style="line-height: 18px !important;" [options]="{ label: 'signatureSideSelli.edit.numberOfLines', labelFor: 'numberOfLines' }"></cdx-label>
        </div>
        <input
          id="numberOfLines"
          type="number"
          class="form-control"
          min="1"
          max="10"
          formControlName="numberOfLines" />
      </div>

      <div class="form-group col-12 form-group--no-margin-bottom">
        <cdx-label style="line-height: 18px !important;" [options]="{ label: 'signatureSideSelli.edit.requerid', labelFor: 'required' }"></cdx-label>
        <div class="required-wrapper">
          <cdx-radio
            class="mr-3"
            [canRemoveSelection]="false"
            [options]="requiredYes"
            (checked)="changeYes($event)"
            [isChecked]="checkedRequiredState">
          </cdx-radio>
          <cdx-radio
            [canRemoveSelection]="false"
            [options]="requiredNo"
            (checked)="changeNo($event)"
            [isChecked]="!checkedRequiredState">
          </cdx-radio>
        </div>
        <div class="text-helper" *ngIf="customField?.fieldType === customFieldTypeEnum.CheckboxField" >{{ 'signatureSideSelli.edit.selectionRequiredDescription' | translate}}</div>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer justify-content-flex-end">
  <button class="cdx-button cdx-button--secondary cdx-button--outline cdx-button--danger mr-2" (click)="onDelete()">
    <span class="cdx-button__text">{{ 'signatureSideSelli.edit.delete' | translate }}</span>
  </button>
  <button *ngIf="!customField?.isNew" class="cdx-button cdx-button--secondary cdx-button--outline mr-2" (click)="onClose()">
    <span class="cdx-button__text">{{ 'signatureSideSelli.edit.cancel' | translate }}</span>
  </button>
  <button class="cdx-button cdx-button--primary" (click)="onConfirm()">
    <span class="cdx-button__text">{{ 'signatureSideSelli.edit.save' | translate }}</span>
  </button>
</div>
